import React, { useEffect, useRef, useState } from 'react';

const DeferredSection = ({
  children,
  className = '',
  minHeight = 420,
  rootMargin = '320px 0px',
}) => {
  const [shouldRender, setShouldRender] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return undefined;

    if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') {
      setShouldRender(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setShouldRender(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [rootMargin]);

  return (
    <div
      ref={containerRef}
      className={className}
      style={shouldRender ? undefined : { minHeight }}
    >
      {shouldRender ? (
        children
      ) : (
        <div className="flex items-center justify-center py-20 text-xs uppercase tracking-widest text-neutral-500">
          Preparing section...
        </div>
      )}
    </div>
  );
};

export default DeferredSection;
